// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.datepicker-wrapper .react-datepicker__month-container {
  /* background-color: rgb(166, 237, 100); */
  height: -moz-fit-content;
  height: fit-content;
  padding: 0px 10px 10px !important;
  /* border: 1px solid red; */
}

.datepicker-wrapper .react-datepicker__day {
  border-radius: 50%;
  width: 28px;
  height: 28px;
  font-family: "Poppins";
  font-weight: 400;
  font-size: 16px;
  line-height: 30px;
  letter-spacing: -0.45px;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  margin: 4px;
  /* border: 0.5px solid black; */
  text-align: center;
  transition: none;
  &:hover {
    background-color: rgba(0, 0, 0, 0.219);
    border-radius: 50%;
  }
}
/* Grey out disabled dates */
.react-datepicker__day--disabled {
  color: #999 !important;
  background-color: #f0f0f0 !important;
  cursor: not-allowed;
  opacity: 0.6;
  border: none;
}
.datepicker-wrapper .custom-header {
  width: 100%;
  height: 44px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 2px;
  margin-right: auto;
  margin-left: auto;
}

.datepicker-wrapper .react-datepicker__day-names {
  display: flex;
  gap: 5px;
}

.datepicker-wrapper .react-datepicker__day-names .react-datepicker__day-name {
  width: 19px;
  height: 18px;
  line-height: 25px;
  /* font-family: sans-serif Pro; */
  font-weight: 400;
  font-size: 13px;
  color: #444444;
}

.datepicker-wrapper .react-datepicker__day--selected,
.datepicker-wrapper .react-datepicker__day--selected:hover {
  background-color: #4caf50 !important;
  color: white !important;
  font-weight: bold;
  border: none;
  border-radius: 50%;
}

@media (max-width: 1199px) {
  .datepicker-wrapper .react-datepicker__day {
    width: 22px;
    height: 22px;
    line-height: 22px;
    font-size: 12px;
  }

  .datepicker-wrapper .react-datepicker__day-names .react-datepicker__day-name {
    width: 12px;
    height: 16px;
    line-height: 18px;
    font-size: 11px;
  }

  .datepicker-wrapper .custom-header {
    font-size: 13px;
    padding: 0 2px;
  }

  .datepicker-wrapper .react-datepicker__month-container {
    padding: 2px 4px;
  }

  .selection-year {
    font-size: 13px;
  }

  .month-text {
    font-size: 13px;
  }
}

/* large screen */
@media (min-width: 1700px) {
  .datepicker-wrapper .react-datepicker__day {
    width: 32px;
    height: 32px;
    line-height: 33px;
    font-size: 15px;
  }

  .datepicker-wrapper .react-datepicker__day-names .react-datepicker__day-name {
    width: 24px;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
  }

  .datepicker-wrapper .custom-header {
    /* height: 50px; */
    font-size: 16px;
    padding: 0 4px;
    background-color: yellowgreen;
  }

  .datepicker-wrapper .react-datepicker__month-container {
    padding: 4px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/order_client_details/components/client_calendar/clientCalendarStyle.css"],"names":[],"mappings":"AAAA;EACE,0CAA0C;EAC1C,wBAAmB;EAAnB,mBAAmB;EACnB,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB;IACE,sCAAsC;IACtC,kBAAkB;EACpB;AACF;AACA,4BAA4B;AAC5B;EACE,sBAAsB;EACtB,oCAAoC;EACpC,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;EACpC,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,6BAA6B;EAC/B;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":[".datepicker-wrapper .react-datepicker__month-container {\n  /* background-color: rgb(166, 237, 100); */\n  height: fit-content;\n  padding: 0px 10px 10px !important;\n  /* border: 1px solid red; */\n}\n\n.datepicker-wrapper .react-datepicker__day {\n  border-radius: 50%;\n  width: 28px;\n  height: 28px;\n  font-family: \"Poppins\";\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 30px;\n  letter-spacing: -0.45px;\n  display: inline-block;\n  text-align: center;\n  cursor: pointer;\n  margin: 4px;\n  /* border: 0.5px solid black; */\n  text-align: center;\n  transition: none;\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.219);\n    border-radius: 50%;\n  }\n}\n/* Grey out disabled dates */\n.react-datepicker__day--disabled {\n  color: #999 !important;\n  background-color: #f0f0f0 !important;\n  cursor: not-allowed;\n  opacity: 0.6;\n  border: none;\n}\n.datepicker-wrapper .custom-header {\n  width: 100%;\n  height: 44px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 2px;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n.datepicker-wrapper .react-datepicker__day-names {\n  display: flex;\n  gap: 5px;\n}\n\n.datepicker-wrapper .react-datepicker__day-names .react-datepicker__day-name {\n  width: 19px;\n  height: 18px;\n  line-height: 25px;\n  /* font-family: sans-serif Pro; */\n  font-weight: 400;\n  font-size: 13px;\n  color: #444444;\n}\n\n.datepicker-wrapper .react-datepicker__day--selected,\n.datepicker-wrapper .react-datepicker__day--selected:hover {\n  background-color: #4caf50 !important;\n  color: white !important;\n  font-weight: bold;\n  border: none;\n  border-radius: 50%;\n}\n\n@media (max-width: 1199px) {\n  .datepicker-wrapper .react-datepicker__day {\n    width: 22px;\n    height: 22px;\n    line-height: 22px;\n    font-size: 12px;\n  }\n\n  .datepicker-wrapper .react-datepicker__day-names .react-datepicker__day-name {\n    width: 12px;\n    height: 16px;\n    line-height: 18px;\n    font-size: 11px;\n  }\n\n  .datepicker-wrapper .custom-header {\n    font-size: 13px;\n    padding: 0 2px;\n  }\n\n  .datepicker-wrapper .react-datepicker__month-container {\n    padding: 2px 4px;\n  }\n\n  .selection-year {\n    font-size: 13px;\n  }\n\n  .month-text {\n    font-size: 13px;\n  }\n}\n\n/* large screen */\n@media (min-width: 1700px) {\n  .datepicker-wrapper .react-datepicker__day {\n    width: 32px;\n    height: 32px;\n    line-height: 33px;\n    font-size: 15px;\n  }\n\n  .datepicker-wrapper .react-datepicker__day-names .react-datepicker__day-name {\n    width: 24px;\n    height: 20px;\n    line-height: 20px;\n    font-size: 14px;\n  }\n\n  .datepicker-wrapper .custom-header {\n    /* height: 50px; */\n    font-size: 16px;\n    padding: 0 4px;\n    background-color: yellowgreen;\n  }\n\n  .datepicker-wrapper .react-datepicker__month-container {\n    padding: 4px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
